/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const PencilFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m12.9 6.85 4.24 4.25-9.9 9.9H3v-4.25zm1.41-1.41 2.12-2.12a1 1 0 0 1 1.42 0l2.83 2.83a1 1 0 0 1 0 1.41l-2.12 2.12z" />
  </Icon>
);
